import state from './testbankState';
import mutations from './testbankMutations';
import getters from './testbankGetters';
import actions from './testbankActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
